import { Box, Typography } from '@mui/material';
import { getBuddhistYear } from '@Utils/datetime';

type GasEmissionMessageType = {
  year?: number;
  percent?: number;
  quantity?: number;
};

export const GasEmissionUnit = () => (
  <Typography component={'span'}>
    tCO<sub>2</sub>e
  </Typography>
);

const GasEmissionMessage = (props: GasEmissionMessageType) => {
  const { year, percent, quantity } = props;
  const buddhistYear = getBuddhistYear(year);
  const quantityFormatted =
    quantity && Intl.NumberFormat('en').format(quantity);

  if (year) {
    if (percent && !quantity) {
      return (
        <Box>
          <Typography>
            {buddhistYear}: ลด {percent}% เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            {year}: Reduce {percent}% compared to base year.
          </Typography>
        </Box>
      );
    } else if (!percent && quantity) {
      return (
        <Box>
          <Typography>
            {buddhistYear}: ลด {quantityFormatted} <GasEmissionUnit />{' '}
            เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            {year}: Reduce {quantityFormatted} <GasEmissionUnit /> compared to
            base year.
          </Typography>
        </Box>
      );
    } else if (percent && quantity) {
      return (
        <Box>
          <Typography>
            {buddhistYear}: ลด {percent}% หรือ {quantityFormatted}{' '}
            <GasEmissionUnit /> เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            {year}: Reduce {percent}% or {quantityFormatted} <GasEmissionUnit />{' '}
            compared to base year.
          </Typography>
        </Box>
      );
    } else if (!percent && !quantity) {
      return (
        <Box>
          <Typography>{buddhistYear}</Typography>
          <Typography mt={2}>{year}</Typography>
        </Box>
      );
    }
  }

  if (!year) {
    if (percent && !quantity) {
      return (
        <Box>
          <Typography>ลด {percent}% เทียบกับปีฐาน</Typography>
          <Typography mt={2}>
            Reduce {percent}% compared to base year.
          </Typography>
        </Box>
      );
    } else if (!percent && quantity) {
      return (
        <Typography>
          ลด {quantityFormatted} <GasEmissionUnit /> เทียบกับปีฐาน
        </Typography>
      );
    } else if (percent && quantity) {
      return (
        <Typography>
          ลด {percent}% หรือ {quantityFormatted} <GasEmissionUnit />{' '}
          เทียบกับปีฐาน
        </Typography>
      );
    }

    return <Typography>-</Typography>;
  }
};

export default GasEmissionMessage;
